import React from "react";
import ReactDOM from "react-dom";
import Minter from "./components/Minter";
import "./assets/css/style.css";

ReactDOM.render(
  <React.StrictMode>
    <Minter />
  </React.StrictMode>,
  document.getElementById("root")
);
